// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const INVALID_STORAGE_INPUT = 'InvalidStorageInput';

export { INVALID_STORAGE_INPUT };
//# sourceMappingURL=constants.mjs.map
